import React from 'react';

/**
 * Botón flotante circular — abre el panel de citas pendientes.
 */
export default function PacienteCitasFab({
  count = 0,
  onClick,
  hidden = false,
  active = false,
  label: labelText = 'Pendientes',
}) {
  const hasPending = count > 0;
  const countLabel = count > 99 ? '99+' : String(count);
  const ariaLabel = hasPending
    ? `${count} ${count === 1 ? 'cita' : 'citas'} ${labelText.toLowerCase()} por confirmar`
    : `Abrir agenda de citas`;

  return (
    <button
      type="button"
      className={[
        'pd-citas-fab',
        hidden ? 'pd-citas-fab--hidden' : '',
        active ? 'pd-citas-fab--active' : '',
        hasPending ? 'pd-citas-fab--pending' : 'pd-citas-fab--idle',
      ].filter(Boolean).join(' ')}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-expanded={active}
      title={ariaLabel}
    >
      <i className="bi bi-calendar2-week pd-citas-fab__icon" aria-hidden />

      {hasPending ? (
        <span className="pd-citas-fab__badge" aria-hidden>
          {countLabel}
        </span>
      ) : null}

      <span className="pd-citas-fab__tip" aria-hidden>
        <span className="pd-citas-fab__tip-label">{labelText}</span>
        {hasPending ? (
          <span className="pd-citas-fab__tip-count">{countLabel} por confirmar</span>
        ) : (
          <span className="pd-citas-fab__tip-count">Ver agenda</span>
        )}
      </span>
    </button>
  );
}
